import T from 'utils/T';
import ex from 'utils/ex';

export default function PatternBox(props) {
  const {
    pattern,
    description,
  } = props || {};
  return (
    <div {...ex('PatternBox', props)}>
      <div {...ex('Pattern')}>
        {pattern}
      </div>
      <div {...ex('Description')}>
        {description}
      </div>
    </div>
  );
}
